const inputCls =
  "w-full bg-onyx/60 border border-ice/10 rounded-lg px-3.5 py-2.5 text-sm text-ice placeholder:text-muted-foreground/50 outline-none focus:border-royal transition-colors";

export function LangTabs({ editLang, setEditLang }) {
  return (
    <div className="flex items-center gap-2 border border-ice/10 rounded-full p-0.5 w-fit" data-testid="admin-lang-tabs">
      {[
        ["it", "Italiano"],
        ["en", "English"],
      ].map(([l, label]) => (
        <button
          key={l}
          data-testid={`admin-lang-${l}`}
          onClick={() => setEditLang(l)}
          className={`px-3.5 py-1.5 rounded-full text-xs font-mono uppercase transition-colors ${
            editLang === l ? "bg-royal text-white" : "text-muted-foreground hover:text-ice"
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export function BField({ label, field, obj, editLang, type = "text", bilingual = true, onChange }) {
  const value = bilingual ? obj?.[field]?.[editLang] ?? "" : obj?.[field] ?? "";
  const handle = (v) => {
    if (bilingual) onChange({ ...obj, [field]: { ...(obj?.[field] || {}), [editLang]: v } });
    else onChange({ ...obj, [field]: v });
  };
  return (
    <div>
      <label className="block text-xs font-mono uppercase tracking-[0.15em] text-muted-foreground mb-1.5">{label}</label>
      {type === "textarea" ? (
        <textarea rows={3} value={value} onChange={(e) => handle(e.target.value)} className={inputCls} />
      ) : (
        <input value={value} onChange={(e) => handle(e.target.value)} className={inputCls} />
      )}
    </div>
  );
}

export function LinesField({ label, field, obj, editLang, onChange }) {
  const arr = obj?.[field]?.[editLang] || [];
  return (
    <div>
      <label className="block text-xs font-mono uppercase tracking-[0.15em] text-muted-foreground mb-1.5">
        {label} <span className="normal-case tracking-normal">(una voce per riga)</span>
      </label>
      <textarea
        rows={Math.max(3, arr.length)}
        value={arr.join("\n")}
        onChange={(e) =>
          onChange({ ...obj, [field]: { ...(obj?.[field] || {}), [editLang]: e.target.value.split("\n").filter((s) => s.trim() !== "") } })
        }
        className={inputCls}
      />
    </div>
  );
}

export function FieldRenderer({ field, obj, editLang, onChange }) {
  if (field.type === "lines") return <LinesField label={field.label} field={field.key} obj={obj} editLang={editLang} onChange={onChange} />;
  return (
    <BField
      label={field.label}
      field={field.key}
      obj={obj}
      editLang={editLang}
      type={field.type}
      bilingual={field.bilingual !== false}
      onChange={onChange}
    />
  );
}
